import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {HomePageHeaderArenaRatioImageWrapperCasino888Box} from "./home-page-header-arena-ratio-image-wrapper.caisno888.box";
import {HomePageHeaderArenaRatioImageWrapperDefaultBox} from "./home-page-header-arena-ratio-image-wrapper.default.box";

export const HomePageHeaderArenaRatioImageWrapperBox = styledByTheme(HomePageHeaderArenaRatioImageWrapperDefaultBox)
    .forCasino888(HomePageHeaderArenaRatioImageWrapperCasino888Box)
    .apply()